<template>
  <div class="currency">
    <div class="header">
      <div class="title">通用解决方案</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div class="list">
          <div
            class="item"
            v-for="item in leftList"
            :key="item.id"
            :style="
              item.id == titleId
                ? `background-image: url(${item.back});`
                : 'background-color: #fafbfe;'
            "
            @mouseenter="currencyEnter(item.id)"
          >
            <img :src="item.id == titleId ? item.open : item.close" alt="" />
            <div
              class="title"
              :style="item.id == titleId ? `color: #fff;` : ''"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="list">
          <div class="item" v-for="item in rightList" :key="item.id">
            <div
              class="box"
              v-if="item.id == titleId"
              :style="`background-image: url(${item.back});`"
            >
              <div class="blur">
                <div class="title">{{ item.title }}</div>
                <div class="text">{{ item.text }}</div>
                <router-link :to="item.path">
                  <div class="more">
                    <div>查看详情</div>
                    <img :src="more" alt="" />
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import currencyOpen1 from "../../../assets/programme/currencyOpen1.png";
import currencyOpen2 from "../../../assets/programme/currencyOpen2.png";
import currencyOpen3 from "../../../assets/programme/currencyOpen3.png";
import currencyOpen4 from "../../../assets/programme/currencyOpen4.png";

import currencyClose1 from "../../../assets/programme/currencyClose1.png";
import currencyClose2 from "../../../assets/programme/currencyClose2.png";
import currencyClose3 from "../../../assets/programme/currencyClose3.png";
import currencyClose4 from "../../../assets/programme/currencyClose4.png";

import currencyDetails1 from "../../../assets/programme/currencyDetails1.png";
import currencyDetails2 from "../../../assets/programme/currencyDetails2.png";
import currencyDetails3 from "../../../assets/programme/currencyDetails3.png";
import currencyDetails4 from "../../../assets/programme/currencyDetails4.png";

import currencyBack1 from "../../../assets/programme/currencyBack1.png";
import currencyBack2 from "../../../assets/programme/currencyBack2.png";
import currencyBack3 from "../../../assets/programme/currencyBack3.png";

import more from "../../../assets/programme/more.png";

export default {
  setup() {
    return reactive({
      more: more,
      titleId: 1,
      leftList: [
        {
          id: 1,
          open: currencyOpen1,
          close: currencyClose1,
          title: "无人门岗",
          back: currencyBack1,
        },
        {
          id: 2,
          open: currencyOpen2,
          close: currencyClose2,
          title: "智能安防",
          back: currencyBack1,
        },
        {
          id: 3,
          open: currencyOpen3,
          close: currencyClose3,
          title: "智能消防",
          back: currencyBack2,
        },
        {
          id: 4,
          open: currencyOpen4,
          close: currencyClose4,
          title: "财务管理",
          back: currencyBack3,
        },
      ],
      rightList: [
        {
          id: 1,
          back: currencyDetails1,
          title: "无人门岗解决方案",
          text: "去人工化岗亭管理  停车场降本增效",
          path: "/pc/programme/doorpost",
        },
        {
          id: 2,
          back: currencyDetails2,
          title: "智能安防解决方案",
          text: "行业智能视觉应用  AI大数据监控视频",
          path: "/pc/programme/security",
        },
        {
          id: 3,
          back: currencyDetails3,
          title: "智能消防解决方案",
          text: "物联网采集消防信息  打造可视化物联网消防平台",
          // path: "/pc/programme/firecontrol",
          path: '',
        },
        {
          id: 4,
          back: currencyDetails4,
          title: "财务管理解决方案",
          text: "物业数字化财务系统综合应用",
          // path: "/pc/programme/financeadmin",
          path: '',
        },
      ],
    });
  },
  methods: {
    currencyEnter(id) {
      this.titleId = id;
    },
  },
};
</script>

<style scoped>
.currency {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-bottom: 155px;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}

.body .left .list {
  width: 480px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.body .left .list .item {
  width: 230px;
  height: 118px;
  background-size: 100%, 100%;
  background-repeat: no-repeat;
  margin-bottom: 20px;
  text-align: center;
  cursor: pointer;
  background-position: center;
}
.body .left .list .item:hover {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    background-size: 100%, 100%;
  }
  100% {
    background-size: 120%, 120%;
  }
}
.body .left .list .item img {
  width: 28px;
  margin-top: 20px;
}
.body .left .list .item .title {
  margin-top: 20px;
}

.body .right .list .item .box {
  display: flex;
  align-items: flex-end;
  width: 680px;
  height: 256px;
  background-size: 100%, 100%;
  background-position: center;
}
.body .right .list .item .box:hover {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    background-size: 100%, 100%;
  }
  100% {
    background-size: 120%, 120%;
  }
}
.body .right .list .item .box .blur {
  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  backdrop-filter: blur(30px);
  padding: 16px 30px;
}
.body .right .list .item .box .blur .title {
  font-size: 16px;
}
.body .right .list .item .box .blur .text {
  font-size: 12px;
  margin-top: 10px;
}
.body .right .list .item .box .blur .more {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-top: 20px;
  cursor: pointer;
  color: #fff;
}
.body .right .list .item .box .blur .more img {
  width: 14px;
  margin-left: 8px;
}
</style>
